// extracted by mini-css-extract-plugin
export default {"OrderMap":"OrderMap_OrderMap__2iIBm","OrderMap__preloader":"OrderMap_OrderMap__preloader__1KU47","spin":"OrderMap_spin___3GtQ"};